export function renderIf(condition, component) {
  if (condition) return component;
  return '';
}
